const config = {
  clientName: process.env.REACT_APP_CLIENT_NAME,
  clientUrl: process.env.REACT_APP_CLIENT_URL,
  title: process.env.REACT_APP_TITLE,
  companyName: process.env.REACT_APP_COMPANY_NAME,
  logo: process.env.REACT_APP_LOGO,
}
export default config

